export default "__VITE_ASSET__jdvYQqQTk4$W1kZY5QpHJg__"